const PrivateLessonActionTypes = {
	SET_SELECTED_PRIVATE_LESSON: "SET_SELECTED_PRIVATE_LESSON",
};

export default PrivateLessonActionTypes;
